import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import TableRowField from "components/TableRowField"
import _ from "lodash"
import helpers from "helpers/helpers"

class OpenHouse extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: {
				open_house: "",
			},
			data: {
				address: "",
			},
		}
	}

	componentDidMount() {
		let open = _.get(this.props, `data.open_house`)
		if (open) {
			this.setState({ fields: { open_house: open } })
		}
	}

	validation = () => {
		let model = {
			open_house: Yup.array()
				.of(
					Yup.object({
						times: Yup.object({
							start: Yup.number().required(`Date/Time is required.`),
							end: Yup.number().required(`Date/Time is required.`),
						}),
					})
				)
				.required("Date/Time is required."),
		}
		return Yup.object().shape(model)
	}

	formLayout = (f) => {
		//console.log(f)
		// the picker opens by default because it auto-focuses the first input..
		return (
			<div id="openHouseModal">
				<Form>
					<TableRowField
						align="left"
						delete={true}
						initRow={true}
						appendUser={true}
						fields={[
							{
								type: "datetimepicker",
								name: "times",
								header: "Date/Time",
							},
							{
								type: "text",
								name: "notes",
								header: "Notes",
							},
						]}
						data={f.values.open_house}
						onChange={(v) => f.setFieldValue("open_house", v)}
					/>

					<div className="flex justify-between mt-10">
						<input type="submit" value="Submit" className={`${helpers.submitClasses(f)}`} />
						<span
							className="text-white bg-red-500 text-sm rounded-lg p-1 inline-block cursor-pointer"
							onClick={() => this.removeOpenHouse()}>
							Remove all open houses
						</span>
					</div>
				</Form>
			</div>
		)
	}

	removeOpenHouse = () => {
		let values = {}
		values.open_house = null
		values.id = this.props.data.id
		values.action = "modifyOpenHouse"
		submitData("mainIngest", values)
			.then((data) => {
				this.props.notify(data, this.props.name)
			})
			.catch((e) => {
				this.props.notify(e, this.props.name)
			})
	}

	render() {
		return (
			<div className="modal">
				<h3>Upcoming Open Houses for {this.props.data.address}</h3>
				<p className="text-sm">
					Select a date and time for this home to show as an Open House on the Community website. Only homes
					that are completed or nearly completed should be listed as an Open House. Once submitted, changes
					may take up to an hour to be posted on the public site.
				</p>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					enableReinitialize
					//validateOnMount={true}
					onSubmit={(values) => {
						values.id = this.props.data.id
						values.action = "modifyOpenHouse"
						_.forEach(values.open_house, (v,k) => {
							if(!v.times) _.remove(values.open_house, (r,key) => key == k)
						})
						submitData("mainIngest", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={(f) => this.formLayout(f)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(OpenHouse)
